module.exports = __webpack_public_path__ + "static/media/info-website.cceb7ef7.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/info/info-website.png
// module id = 1749
// module chunks = 0